import React from 'react'

export const EventAnalyze = () => {
    return null
}
